let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jzsar")).then(() => parcelRequire('8V4ts'));